<template>
  <div
    class="exam"
    style="-moz-user-select: none"
    v-loading="loading"
    element-loading-text="加载中,请稍后..."
    @keyup="cutQues($event)"
    tabindex="0"
  >
    <el-container>
      <!-- 考试时间安排 -->
      <el-header height="auto">
        <div height="90px" v-show="exam.type != 4">
          <el-row v-if="!disabled">
            <el-col :span="10">考生姓名：{{ mem_name }}</el-col>
            <el-col :span="14">身份证号：{{ idcard }}</el-col>
          </el-row>
          <el-row v-else>
            <el-col :span="10">考生姓名：{{ mem_name }}</el-col>
            <el-col :span="14">身份证号：{{ idcard }}</el-col>
          </el-row>
          <el-row v-if="!disabled">
            <el-col :span="10">开放时间：{{ exam.start_time }}</el-col>

            <el-col :span="14">关闭时间：{{ exam.end_time }}</el-col>
          </el-row>
          <el-row v-else>
            <el-col :span="10">得分：{{ result.score }}</el-col>
            <el-col :span="14">答对：{{ result.right_sum }}个</el-col>
          </el-row>
          <el-row v-if="!disabled">
            <el-col :span="10">考试时长：{{ exam.minutes }}分钟</el-col>
            <el-col :span="14"
              >已用时长：{{ useMinute }}分{{ useSecond }}秒</el-col
            >
          </el-row>
          <el-row v-else>
            <el-col :span="10">错题：{{ result.wrong_sum }}个</el-col>
            <el-col :span="14">漏题：{{ result.leakage_sum }}个</el-col>
          </el-row>
        </div>
      </el-header>

      <el-main>
        <!-- 题型、分数 -->
        <div class="publicDesc">
          <span class="examGrade">
            <strong>{{ i + 1 }}</strong>
            <strong>/{{ ques.length }}</strong>
            <span>
              <span v-show="exam.type != 4"
                >（分值：{{ currentQues.score }}分）</span
              >
            </span>
          </span>
          <span v-show="exam.type != 4">总分：{{ exam.score }}</span>
        </div>
        <el-progress
          :percentage="progress"
          type="line"
          :show-text="false"
        ></el-progress>
        <!--折叠面板  -->
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1" title="查看答题卡">
            <el-row>
              <el-col :span="4" v-for="index in card.endPage" :key="index">
                <el-button
                  :type="
                    ques[(card.curPage - 1) * card.pagesize + index - 1]
                      .circleColor
                  "
                  circle
                  @click="
                    toQuestion((card.curPage - 1) * card.pagesize + index - 1)
                  "
                  >{{ (card.curPage - 1) * card.pagesize + index }}</el-button
                >
              </el-col>
            </el-row>
            <el-pagination
              background
              v-show="ques.length > card.pagesize"
              layout="prev, pager, next"
              :total="ques.length"
              :current-page="card.curPage"
              :page-size="card.pagesize"
              @current-change="showCard"
            >
            </el-pagination>
          </el-collapse-item>
        </el-collapse>
        <!-- 题目 -->
        <div class="content">
          <div>
            <strong> {{ i + 1 }}.</strong>
            <span class="queName" v-html="currentQues.name"></span>
            <span class="quetype"> [ {{ currentQues.queType }} ]</span>
          </div>

          <div class="answers" v-if="currentQues.queType != '填空题'">
            <div v-for="(item, index) in currentQues.options" :key="index">
              <div v-if="currentQues.type == 2">
                <p
                  class="option"
                  :class="{ bgGreen: item.greenBg, bgRed: item.redBg }"
                >
                  <el-checkbox
                    fill="#999"
                    v-model="currentQues.is_select"
                    @change="
                      val => {
                        fun(val, item)
                      }
                    "
                    :label="item.id"
                    :disabled="disabled"
                  >
                    {{ code[index] }}.{{ item.name }}
                  </el-checkbox>
                </p>
              </div>
              <div v-else>
                <p
                  class="option"
                  :class="{ bgGreen: item.greenBg, bgRed: item.redBg }"
                >
                  <el-radio
                    v-model="currentQues.is_select"
                    @change="
                      val => {
                        fun(val, item)
                      }
                    "
                    :label="item.id"
                    :disabled="disabled"
                  >
                    {{ code[index] }}.{{ item.name }}
                  </el-radio>
                </p>
              </div>
            </div>
            <!-- <p v-show="currentQues.showParsing">答案解析：{{currentQues.parsing}}</p> -->
          </div>
          <div class="answers" v-else>
            <br />
            <p
              style="padding:5px"
              v-if="currentQues.circleColor"
              :class="[
                currentQues.circleColor == 'danger'
                  ? 'bgRed'
                  : currentQues.circleColor == 'success'
                  ? 'bgGreen'
                  : '',
              ]"
            >
              {{ currentQues.is_select }}
            </p>
            <el-input
              v-else
              v-model="currentQues.is_select"
              type="textarea"
              :rows="2"
              style="width:320px"
            ></el-input>
            <p v-show="answerShow">
              <b style="color:#1676dd">正确答案</b>：<span
                v-for="item in currentQues.options"
                :key="item.id"
                >{{ item.name }}
                <em v-if="index != currentQues.options.length - 1">
                  /
                </em>
              </span>
            </p>
          </div>
          <div class="footer">
            <el-button
              type
              round
              size="small"
              v-show="i > 0"
              @click="preQuestion"
              >上一题</el-button
            >
            <el-button
              type="primary"
              round
              size="small"
              v-show="i < ques.length - 1"
              @click="nextQuestion"
              >下一题</el-button
            >
          </div>

          <div class="submit" v-if="exam.type != 4">
            <el-button
              type="primary"
              v-if="exam.type != 2 && resetBtn"
              @click="resetPaper"
              >重做</el-button
            >
            <el-button
              type="primary"
              :disabled="disabledBtn"
              v-show="submitBtn"
              @click="submit"
              >交卷</el-button
            >
          </div>
          <div v-else class="submit">
            <el-button type="primary" @click="showAnswer(currentQues)"
              >查看答案</el-button
            >
            <el-button type="warning" @click="toClearRecord"
              >清空记录重新答题</el-button
            >
          </div>
          <div v-if="exam.type != 2" class="examMsg">
            如发现试题有误请截图或拍照保存发送给老师，以便更改。
          </div>
          <div v-if="exam.type == 2" class="examMsg">
            如考试途中碰到无法解决的意外情况，请尽量使用手机录像并保存，以联系老师处理。
          </div>
          <el-dialog
            title="警告"
            :visible.sync="dialogWarning"
            width="400px"
            center
          >
            <p v-if="warning == 1">
              请勿在考试的过程打开除考试外的其他页面。
            </p>
            <p v-if="warning == 2">
              考生请勿在考试时间关闭考试页面，否则将有可能被视为作弊！（如碰到异常情况请拍照或录像取证提交至老师）
            </p>
            <p v-if="warning == 3">
              检测到考生考试过程中多次使用其他页面，请考生严格遵守考试规则，否则将有可能被视为作弊！
            </p>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="dialogWarning = false"
                >知道了</el-button
              >
            </span>
          </el-dialog>
          <el-dialog
            title="提示"
            :visible.sync="dialogSubmit"
            width="400px"
            center
          >
            <p>
              检测到你有未提交的试卷，请立即提交！
            </p>

            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="handlePaper"
                >立即提交</el-button
              >
            </span>
          </el-dialog>
          <el-dialog
            title="提示"
            :visible.sync="warningShow"
            width="400px"
            center
          >
            <p v-if="warning_type == 1">
              检测到摄像头多次未捕捉到考生完整面部，请考生严格遵守考试规则，否则将有可能被视为作弊！
            </p>
            <p v-if="warning_type == 2">
              检测到考生考试时有其他人员频繁出入，请考生严格遵守考试规则，否则将有可能被视为作弊！
            </p>
            <p v-if="warning_type == 3">
              检测到考生考试时存在非本人考试，请考生严格遵守考试规则，否则将有可能被视为作弊！
            </p>
            <p v-if="warning_type == 4">
              检测到考生未开启摄像头，请考生打开电脑摄像头。
            </p>
            <p v-if="warning_type == 5">
              检测到考生多次关闭摄像头，请考生严格遵守考试规则，否则将有可能被视为作弊！
            </p>

            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="warningShow = false"
                >知道了</el-button
              >
            </span>
          </el-dialog>
          <el-dialog
            title="提示"
            :visible.sync="changeShow"
            width="400px"
            center
          >
            <p>
              请尝试更换浏览器！
            </p>

            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="changeShow = false"
                >知道了</el-button
              >
            </span>
          </el-dialog>
        </div>
      </el-main>
    </el-container>
    <Result
      :result="result"
      :type="exam.type"
      v-if="showResult"
      @checkPaper="checkPaper"
      @resetPaper="resetPaper"
    ></Result>
    <div>
      <div class="video">
        <video
          autoplay="autoplay"
          @loadedmetadata="onPlay"
          id="inputVideo"
          muted="muted"
        ></video>
        <canvas id="overlay" />
      </div>
      <div
        style="color:red;font-size:16px;position: fixed;top:170px;right:40px"
      >
        <i class="el-icon-video-camera"></i> 考试全程监控中<span class="dot"
          >...</span
        >
      </div>
    </div>

    <canvas
      id="canvas1"
      :height="vh"
      :width="vw"
      style="display: none"
    ></canvas>

    <!-- <div id="imgs" style="display: none" >
      <img id="sfz" src="" alt="">
       <img id="sf" src="" alt="">
       <canvas id="qq" width="500" height="400"></canvas>
    </div> -->
  </div>
</template>
<script>
let mediaStreamTrack
let video
let canvas1
let context1
let exArray = [] //存储设备源ID
const qiniu = require('qiniu-js')

import Result from './result'
import { shuffle } from '../assets/js/const'
import { isios } from '../components/js/isIos.js'
import { shuffleType } from '../assets/js/shuffleType.js'

import * as faceapi from 'face-api.js'
import {
  getFaceDetectorOptions,
  TINY_FACE_DETECTOR,
  isFaceDetectionModelLoaded,
  changeFaceDetector,
} from '../assets/js/face'

export default {
  data() {
    return {
      exam: {},
      ques: [],
      i: 0, //当前题目的索引
      sum: 0, //总分
      code: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
      progress: 0, //进度条
      showResult: false, //展示结果
      submitBtn: true, //控制交卷按钮显示与否
      disabled: false, //选项可选与否
      result: {},
      currentQues: {}, //当前题目
      useMinute: 0,
      useSecond: 0,
      timer: null, //定时器
      endTimer: null,
      obj: {},
      activeNames: [],
      resetBtn: false,
      disabledBtn: false,
      countdown: 0,
      num: 0,
      is_new: 0,
      loading: true,
      card: {
        pagesize: 100,
        curPage: 1,
        endPage: 0,
      },
      is_img: [],
      vh: 480,
      vw: 600,
      sf: '',
      dialogWarning: false,
      cont: 0,
      warning: 0,
      dialogSubmit: false,
      count: 0,
      num: 0,
      count_overstep: 0,
      num_overstep: 0,
      count_not: 0,
      num_not: 0,
      count_media: 0,
      num_media: 0,
      warningShow: false,
      warning_type: 0,
      token: '',
      invigilate_data: '',
      CoverputExtra: {},
      config: {},
      base64Data: '',
      trainer_img: '',
      request_type: '',
      request_num: '0',
      changeShow: false,
      numStatistics: {
        num_not: 0,
        count_not: 0,
        num_overstep: 0,
        count_overstep: 0,
        num: 0,
        count: 0,
        num_media: 0,
        count_media: 0,
        request_type: '',
        request_num: 0,
        cont: 0,
      },
      idcard: '',
      mem_name: '',
      answerShow: false,
      imgData:
        'data:image/png;base64,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',
    }
  },
  components: { Result },

  watch: {
    $route: 'toRefresh',
    ques(val, oldVal) {
      //普通的watch监听

      if (val.length > this.card.pagesize) {
        this.card.endPage = 100
      } else {
        this.card.endPage = val.length
      }
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (
  //     from.name == 'entrance' ||
  //     from.name == 'verify' ||
  //     from.name == 'entranceby'
  //   ) {
  //     next()
  //   } else {
  //     next('/entrance/' + to.params.id)
  //   }
  // },
  created() {
    this.idcard = localStorage.getItem('idcard')
    this.mem_name = localStorage.getItem('mem_name')
    if (!this.IsPC()) {
      this.$alert('请在电脑端打开', '', {
        confirmButtonText: '返回',
        callback: action => {
          window.history.go(-3)
        },
      })
      return
    }
    if (this.Storage.getStorage('illegal' + this.$route.params.id)) {
      this.numStatistics = this.Storage.getStorage(
        'illegal' + this.$route.params.id
      )
    }

    // this.init()
    this.getUserAvatar()

    this.$nextTick(() => {
      video = document.querySelector('video')
      canvas1 = document.getElementById('canvas1')
      context1 = canvas1.getContext('2d')

      // 禁用右键
      document.oncontextmenu = new Function('event.returnValue=false')
      // 禁用选择
      document.onselectstart = new Function('event.returnValue=false')
    })
  },
  mounted() {
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.addEventListener('unload', e => this.unloadHandler(e))
    if (this.Storage.getStorage('ai') == 1) {
      // 监听窗口关闭和窗口刷新
      this.beforeunloadH()
      // 监听当前页面 显示状态
      window.addEventListener('visibilitychange', this.hanldeVisiblityChange)
      // 当页面被销毁时 移除监听
      this.$on('hook:beforeDestroy', () => {
        console.info('销毁了, 移除监听')
        window.removeEventListener(
          'visibilitychange',
          this.hanldeVisiblityChange
        )
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.removeEventListener('unload', e => this.unloadHandler(e))
  },
  methods: {
    getUserAvatar() {
      let _this = this
      this.$http
        .post(process.env.VUE_APP_API_URL + 'userAvatar')
        .then(function(data) {
          if (data.data.code == 200) {
            if (data.data.data.trainer_type != 0) {
              //港澳台用户
              _this.trainer_img = data.data.data.trainer_img
            }
            _this.run()
          } else {
            _this.$message.error(data.data.msg)
          }
        })
        .catch(function(error) {
          console.log(error)
          return
        })
    },
    async run() {
      this.init()
      await changeFaceDetector(TINY_FACE_DETECTOR)
      await faceapi.loadFaceRecognitionModel(
        'https://resource.netclass.cn/weights/'
      )
      let url
      if (this.trainer_img) {
        url = this.trainer_img
      } else {
        url = this.Storage.getStorage('examuser')
      }
      const input = await faceapi.fetchImage(url)
      const inputImgEl = input
      const options = getFaceDetectorOptions()
      const detections = await faceapi.detectAllFaces(inputImgEl, options)
      const faceImages = await faceapi.extractFaces(inputImgEl, detections)
      //document.getElementById('sfz').src=faceImages[0].toDataURL("image/png")
      //  var oCanvas = document.querySelector("#qq"),
      //             oGc = oCanvas.getContext('2d');
      //   oGc.drawImage(document.getElementById('sfz'), 0, 0);
      //             var imgData = oGc.getImageData(0, 0, document.getElementById('sfz').width, document.getElementById('sfz').height),
      //                 data = imgData.data, avg = 0;
      //             for( var i = 0; i < data.length; i += 4 ) {
      //                 avg = ( data[i] + data[i+1] + data[i+2] ) / 3;
      //                 data[i] = avg;
      //                 data[i+1] = avg;
      //                 data[i+2] = avg;
      //             }
      //             console.log(imgData)
      //             //处理完之后，再次输出
      //             oGc.putImageData( imgData, 0, 0 );
      console.log(faceImages)
      setTimeout(() => {
        if (faceImages.length == 0) {
          this.changeShow = true
        }
      }, 2000)
      const img = new Image()
      img.src = faceImages[0].toDataURL('image/png')
      this.sf = await faceapi.computeFaceDescriptor(img)
    },
    async onPlay() {
      let _this = this
      const videoEl = document.getElementById('inputVideo')
      if (videoEl.paused || videoEl.ended || !isFaceDetectionModelLoaded())
        setTimeout(() => _this.onPlay(), 5000)
      const options = getFaceDetectorOptions()
      const result = await faceapi.detectAllFaces(videoEl, options)
      const faceImages = await faceapi.extractFaces(videoEl, result)

      if (result) {
        const canvas = document.getElementById('overlay')
        const dims = faceapi.matchDimensions(canvas, videoEl, true)
        faceapi.draw.drawDetections(canvas, faceapi.resizeResults(result, dims))
        if (result.length == 0) {
          //检测不到考生
          console.log('检测不到考生')
          _this.getPhoto()
          let imgData = document
            .getElementById('canvas1')
            .toDataURL('image/png')
          _this.base64Data = imgData.replace(/^data:image\/\w+;base64,/, '')
          if (imgData == _this.imgData) {
            _this.numStatistics.num_media++
            this.numStatistics.num = 0
            this.numStatistics.num_overstep = 0
            this.numStatistics.num_not = 0
            this.numStatistics.cont = 0

            this.invigilate_media() //关闭摄像头
          } else {
            this.numStatistics.num++
            this.numStatistics.num_overstep = 0
            this.numStatistics.num_not = 0
            this.numStatistics.num_media = 0
            this.numStatistics.cont = 0

            this.invigilate_person() //检测不到考生
          }
        }
        if (result.length > 1) {
          console.log('多人同框')
          this.numStatistics.num_overstep++
          this.numStatistics.num = 0
          this.numStatistics.num_not = 0
          this.numStatistics.num_media = 0
          this.numStatistics.cont = 0
          this.invigilate_multi() //多人同框
        }

        if (result.length == 1) {
          var img = new Image()
          img.src = faceImages[0].toDataURL('image/png')
          // document.getElementById('sf').src = faceImages[0].toDataURL(
          //   'image/png'
          // )
          const image = await faceapi.computeFaceDescriptor(img)
          const distance = faceapi.utils.round(
            faceapi.euclideanDistance(this.sf, image)
          )
          if (distance > 0.45) {
            console.log('非本人')
            this.numStatistics.num_not++
            this.numStatistics.num = 0
            this.numStatistics.num_overstep = 0
            this.numStatistics.num_media = 0
            this.numStatistics.cont = 0
            this.invigilate_oneself() //非本人
          }
        }
        this.Storage.setStorage(
          'illegal' + this.$route.params.id,
          this.numStatistics
        )
      } else {
        const canvas = document.getElementById('overlay')
        var ctx = canvas.getContext('2d')
        ctx.clearRect(0, 0, canvas.width, canvas.height)
      }
      setTimeout(() => _this.onPlay(), 5000)
    },
    invigilate_media() {
      if (
        this.numStatistics.num_media == 20 &&
        this.numStatistics.count_media <= 1
      ) {
        this.numStatistics.num_media = 0
        this.numStatistics.count_media++
        this.warningShow = true
        this.warning_type = 4
        this.invigilate(2, 4) //关闭摄像头
        this.numStatistics.request_type = 'count_media'
      }
      if (
        this.numStatistics.num_media == 120 &&
        this.numStatistics.count_media > 1 &&
        this.numStatistics.request_num < 10
      ) {
        this.getNumMedia()
      }
      if (
        this.numStatistics.num_media == 600 &&
        this.numStatistics.count_media > 10 &&
        this.numStatistics.request_num >= 10
      ) {
        this.getNumMedia()
      }
    },
    invigilate_person() {
      if (this.numStatistics.num == 20 && this.numStatistics.count <= 5) {
        this.numStatistics.num = 0
        this.numStatistics.count++
        this.$message({
          duration: 5000,
          message: '请考生本人保持面部完整的处于摄像头有效范围内！',
          type: 'error',
        })
        this.invigilate(1, 3) //检测不到考生
        if (this.numStatistics.request_type == 'count') {
          this.numStatistics.request_num++
        } else {
          this.numStatistics.request_num = 0
        }
        this.numStatistics.request_type = 'count'
      }

      if (
        this.numStatistics.num == 120 &&
        this.numStatistics.count > 5 &&
        this.numStatistics.request_num < 10
      ) {
        this.getNum()
      }
      if (
        this.numStatistics.num == 3600 &&
        this.numStatistics.count > 10 &&
        this.numStatistics.request_num >= 10
      ) {
        this.getNum()
      }
    },
    invigilate_multi() {
      if (
        this.numStatistics.num_overstep == 20 &&
        this.numStatistics.count_overstep <= 5
      ) {
        this.numStatistics.num_overstep = 0
        this.numStatistics.count_overstep++
        this.$message({
          duration: 5000,
          message: '请保持考试时周边环境除考生外无其他人员！',
          type: 'error',
        })
        this.invigilate(1, 5) //出现多人同框
        if (this.numStatistics.request_type == 'count_overstep') {
          this.numStatistics.request_num++
        } else {
          this.numStatistics.request_num = 0
        }
        this.numStatistics.request_type = 'count_overstep'
      }
      if (
        this.numStatistics.num_overstep == 120 &&
        this.numStatistics.count_overstep > 5 &&
        this.numStatistics.request_num < 10
      ) {
        this.getNumOverstep()
      }
      if (
        this.numStatistics.num_overstep == 600 &&
        this.numStatistics.count_overstep > 10 &&
        this.numStatistics.request_num >= 10
      ) {
        this.getNumOverstep()
      }
    },
    invigilate_oneself() {
      if (
        this.numStatistics.num_not == 20 &&
        this.numStatistics.count_not <= 5
      ) {
        this.numStatistics.num_not = 0
        this.numStatistics.count_not++
        this.$message({
          duration: 5000,
          message:
            '检测到考生面部对比有误，请考生注意将面部完整的出现在摄像有效范围内，请勿让他人替考！',
          type: 'error',
        })
        this.invigilate(1, 1) //检测到非本人
        if (this.numStatistics.request_type == 'count_not') {
          this.numStatistics.request_num++
        } else {
          this.numStatistics.request_num = 0
        }
        this.numStatistics.request_type = 'count_not'
      }

      if (this.num_not == 120 && this.count_not > 5 && this.request_num < 10) {
        this.getNumNot()
      }

      if (
        this.numStatistics.num_not == 600 &&
        this.numStatistics.count_not > 10 &&
        this.numStatistics.request_num >= 10
      ) {
        this.getNumNot()
      }
    },
    getNumMedia() {
      this.numStatistics.num_media = 0
      this.numStatistics.count_media++
      this.warningShow = true
      this.warning_type = 5
      this.invigilate(2, 4) //关闭摄像头
      if (this.numStatistics.request_type == 'count_media') {
        this.numStatistics.request_num++
      } else {
        this.numStatistics.request_num = 0
      }
      this.numStatistics.request_type = 'count_media'
    },
    getNum() {
      this.numStatistics.num = 0
      this.numStatistics.count++
      this.warningShow = true
      this.warning_type = 1
      this.invigilate(2, 3) //检测不到考生
      if (this.numStatistics.request_type == 'count') {
        this.numStatistics.request_num++
      } else {
        this.numStatistics.request_num = 0
      }
      this.numStatistics.request_type = 'count'
    },
    getNumOverstep() {
      this.numStatistics.num_overstep = 0
      this.numStatistics.count_overstep++
      this.warningShow = true
      this.warning_type = 2
      this.invigilate(2, 5) //出现多人同框
      if (this.numStatistics.request_type == 'count_overstep') {
        this.numStatistics.request_num++
      } else {
        this.numStatistics.request_num = 0
      }
      this.numStatistics.request_type = 'count_overstep'
    },
    getNumNot() {
      this.numStatistics.num_not = 0
      this.numStatistics.count_not++
      this.warningShow = true
      this.warning_type = 3
      this.invigilate(2, 1) //检测到非本人
      if (this.numStatistics.request_type == 'count_not') {
        this.numStatistics.request_num++
      } else {
        this.numStatistics.request_num = 0
      }
      this.numStatistics.request_type = 'count_not'
    },
    beforeunloadHandler(event) {
      this._beforeUnload_time = new Date().getTime()
      if (this.$route.name == 'exam_wp') {
        event = event || window.event
        if (event) {
          event.returnValue = '关闭提示'
        }
        return '关闭提示'
      }
    },
    unloadHandler() {
      this._gap_time = new Date().getTime() - this._beforeUnload_time
      // let loginid = this.getCookie('loginid')
      // let jid = this.getCookie('jid')
      // debugger // 关闭能拦住 刷新拦不住
      if (this._gap_time <= 5) {
      } else {
        // $.ajax({
        //   url: 'http://ks.netban.cn/api/invigilate',
        //   // headers: { token: loginid },
        //   beforeSend: function(xhr) {
        //     xhr.setRequestHeader('token', loginid)
        //     xhr.setRequestHeader('numbers', jid)
        //   },
        //   type: 'post',
        //   async: false, //或false,是否异步
        //   data: {
        //     paper_id: this.$route.params.id,
        //     type: 2,
        //     content_type: 6,
        //   },
        //   dataType: 'json',
        //   success: function(data) {},
        //   error: function(data) {},
        // })
      }
    },
    invigilate(type, content_type) {
      let _this = this
      let postData = {
        paper_id: _this.$route.params.id,
        type: type,
        content_type: content_type,
      }
      this.$http
        .post(process.env.VUE_APP_API_URL + 'invigilate', postData)
        .then(function(data) {
          if (data.data.code == 200) {
            _this.invigilate_data = data.data.data
            _this.getQiNiuToken()
          } else {
            _this.$message.error(data.data.msg)
          }
        })
        .catch(function(error) {
          // _this.$message.error({ message: '网络错误,请刷新界面重试' })
          return
        })
    },
    getQiNiuToken() {
      let _this = this
      //获取七牛token
      _this.$http
        .post('https://ks.netban.cn/api/qiniuToken', {
          id: _this.invigilate_data,
        })
        .then(function(data) {
          _this.token = data.data.data
          _this.getPhoto()
          let imgData = document
            .getElementById('canvas1')
            .toDataURL('image/png')
          _this.base64Data = imgData.replace(/^data:image\/\w+;base64,/, '')
          _this.putb64()
        })
        .catch(function() {
          _this.$message.error('网路错误,请刷新界面重试')
          return
        })
    },

    putb64() {
      var pic = this.base64Data
      var url = 'https://upload.qiniup.com/putb64/-1' //非华东空间需要根据注意事项 1 修改上传域名
      var xhr = new XMLHttpRequest()
      // xhr.onreadystatechange = function() {
      //   if (xhr.readyState == 4) {
      //     document.getElementById('myDiv').innerHTML = xhr.responseText
      //   }
      // }
      xhr.open('POST', url, true)
      xhr.setRequestHeader('Content-Type', 'application/octet-stream')
      xhr.setRequestHeader('Authorization', 'UpToken ' + this.token)
      xhr.send(pic)
    },

    cutQues(ev) {
      if (ev.keyCode == 37 || ev.keyCode == 38) {
        if (this.i > 0) {
          this.preQuestion()
        }
      }
      if (ev.keyCode == 39 || ev.keyCode == 40) {
        if (this.i < this.ques.length - 1) {
          this.nextQuestion()
        }
      }
    },
    showCard(val) {
      this.card.curPage = val
      if (val * this.card.pagesize > this.ques.length) {
        this.card.endPage = this.ques.length % this.card.pagesize
      } else {
        this.card.endPage = this.card.pagesize
      }
    },
    hanldeVisiblityChange() {
      if (document.visibilityState === 'hidden') {
        this.invigilate(2, 2) //使用其它窗口
        if (this.numStatistics.request_type == 'cont') {
          this.numStatistics.request_num++
        } else {
          this.numStatistics.request_num = 0
        }
        this.numStatistics.request_type = 'cont'
        this.Storage.setStorage(
          'illegal' + this.$route.params.id,
          this.numStatistics
        )
      } else if (document.visibilityState === 'visible') {
        this.numStatistics.cont++
        this.numStatistics.num_not = 0
        this.numStatistics.num_overstep = 0
        this.numStatistics.num = 0
        this.numStatistics.num_media = 0
        this.dialogWarning = true
        if (this.numStatistics.cont > 2) {
          this.warning = 3
        } else {
          this.warning = 1
        }
      }
    },
    beforeunloadH(e) {
      let _this = this
      window.onbeforeunload = function(e) {
        if (_this.$route.name == 'exam_wp') {
          e = e || window.event
          if (e) {
            e.returnValue = '关闭提示1'
            _this.dialogWarning = true
            _this.warning = 2
          }
          return '关闭提示2'
        } else {
          window.onbeforeunload = null
        }
      }
    },
    init() {
      //初始化试卷信息
      let _this = this
      let id = this.$route.params.id
      let is_new = this.is_new
      if (_this.Storage.getStorage('exampath') == null) {
        //window.history.go(-1);
      }
      _this.getMedia()
      if (_this.Storage.getStorage(id)) {
        //判断本地存储有没有exam和ques如果有则直接赋值，没有则请求接口
        _this.obj = _this.Storage.getStorage(id)
        if (_this.Storage.getStorage('exam' + id)) {
          _this.exam = _this.Storage.getStorage('exam' + id)
        }
        if (_this.Storage.getStorage('ques' + id)) {
          _this.ques = _this.Storage.getStorage('ques' + id)
          _this.currentQues = _this.ques[0]
        }
        if (_this.Storage.getStorage(id).progress) {
          _this.progress = _this.Storage.getStorage(id).progress
        }
        if (_this.Storage.getStorage(id).minute) {
          _this.useMinute = _this.Storage.getStorage(id).minute
        }
        if (_this.Storage.getStorage(id).second) {
          _this.useSecond = _this.Storage.getStorage(id).second
        }
        if (_this.Storage.getStorage(id).is_img) {
          _this.is_img = _this.Storage.getStorage(id).is_img
        }

        if (this.exam.type != 4) {
          _this.useTime()
        }
        this.loading = false
      } else {
        _this.obj = {}
        _this.useMinute = 0
        _this.useSecond = 0
        this.$http
          .get(process.env.VUE_APP_API_URL + 'pen/' + id + '/' + is_new)
          .then(function(data) {
            _this.loading = false
            if (data.data.code == 403) {
              _this.$message.error(data.data.msg)
              _this.$router.push({ name: 'entrance' })
            } else {
              if (data.data.type == 2) {
                //考试卷已考过
                let id = _this.$route.params.id
                _this.$router.push({ name: 'entrance', params: { id: id } })
              } else {
                //没考过的
                _this.exam = data.data.data
                // if (_this.Storage.getStorage(_this.exam.id)) {
                //   _this.dialogSubmit = true
                // }
                _this.Storage.setStorage('exam' + id, _this.exam)
                _this.obj.exam = _this.exam
                let ques = data.data.data.question
                ques.forEach(item => {
                  if (item.type == 2) {
                    item.is_select = []
                  } else {
                    item.is_select = ''
                  }
                  switch (item.type) {
                    case 1:
                      item.queType = '单选题'
                      break
                    case 2:
                      item.queType = '多选题'
                      break
                    case 3:
                      item.queType = '判断题'
                      break
                    case 4:
                      item.queType = '填空题'
                      break
                  }
                })

                if (data.data.code == 200) {
                  //去考试
                  _this.disabled = false
                  if (_this.exam.is_random) {
                    //判断题目是否随机
                    // ques = shuffle(ques);
                    ques = shuffleType(ques)
                  }
                  if (_this.exam.is_option_random) {
                    //判断题目选项是否随机
                    ques.forEach(item => {
                      item.options = shuffle(item.options)
                    })
                  }
                  _this.ques = JSON.parse(JSON.stringify(ques))
                  _this.Storage.setStorage('ques' + id, _this.ques)
                  // _this.Storage.setStorage('ques' + id, ques)
                  // _this.Storage.getStorage('ques' + id)
                  _this.obj.ques = _this.ques
                  _this.currentQues = _this.ques[0]
                  _this.obj.is_img = _this.get_nums(
                    _this.exam.num,
                    _this.exam.verify_nums
                  )
                  _this.useTime()
                } else if (data.data.code == 201) {
                  //做过的测试卷，测验卷、个人卷，显示每道考题的作答情况。
                  _this.resetBtn = data.data.data.is_repeat == 1 ? true : false //显示重做按钮
                  if (_this.Storage.getStorage('ques' + id)) {
                    _this.ques = _this.Storage.getStorage('ques' + id)
                  } else {
                    _this.ques = JSON.parse(JSON.stringify(ques))
                  }
                  _this.currentQues = _this.ques[0]
                  _this.i = 0
                  _this.showResult = false
                  _this.progress = 100
                  _this.submitBtn = false
                  _this.disabled = true

                  _this.result = data.data.results //赋值给结果
                  let exams = _this.ques
                  if (data.data.type !== 2 || data.data.type != 4) {
                    ques.forEach(element => {
                      exams.forEach(exam => {
                        if (exam.id == element.id) {
                          exam.seleted = element.seleted
                          exam.is_right = element.is_right
                        }
                      })
                    })
                    let select = false

                    exams.forEach(exam => {
                      if (exam.type == 4) {
                        _this.result.qusetion.forEach(item => {
                          if (item.question_id == exam.id) {
                            exam.is_select = item.seleted
                            exam.seleted = item.seleted
                          }
                        })
                      } else {
                        exam.is_select = exam.seleted //勾选用户所选选项
                      }
                      let options = exam.options //拿到每道题的选项
                      if (_this.exam.is_show_answer) {
                        _this.answerShow = true
                        options.forEach(option => {
                          //标记所有题目的正确选项
                          if (option.is_right) {
                            option.bgColor = true
                            option.greenBg = true
                          }
                        })
                      }

                      if (exam.type == 2 && exam.seleted[0] != '') {
                        select = true
                      } else if (exam.type != 2 && exam.seleted != '') {
                        select = true
                      }
                      if (!exam.is_right && select) {
                        //如果做错了题
                        exam.circleColor = 'danger' //根据得分情况以及选择与否改变答题卡的颜色
                        options.forEach(option => {
                          //如果做错了题，将错题标记
                          if (exam.type == 1 || exam.type == 3) {
                            if (option.id == exam.seleted) {
                              option.bgColor = true
                              option.redBg = true
                            }
                          } else if (exam.type == 2) {
                            exam.seleted.forEach(i => {
                              if (!option.is_right && option.id == i) {
                                //如果选项是错的，但是选择的选择与该选项的id一样，那么标红
                                option.bgColor = true
                                option.redBg = true
                              }
                            })
                          }
                        })
                      } else if (exam.is_right) {
                        exam.circleColor = 'success'
                      }
                    })
                  }
                } else if (data.data.code == 202) {
                  //顺序答题
                  if (_this.exam.is_random) {
                    //判断题目是否随机
                    ques = shuffle(ques)
                  }
                  if (_this.exam.is_option_random) {
                    //判断题目选项是否随机
                    ques.forEach(item => {
                      item.options = shuffle(item.options)
                    })
                  }
                  _this.ques = JSON.parse(JSON.stringify(ques))
                  _this.Storage.setStorage('ques' + id, _this.ques)
                  _this.obj.ques = _this.ques
                  _this.currentQues = _this.ques[0]
                } else {
                  _this.$message.error(data.data.msg)
                }
              }
            }
          })
          .catch(function(error) {
            _this.loading = false
            _this.$message.error({ message: '网络错误,请刷新界面重试' })
            console.log(error)
            return
          })
      }
    },
    get_nums(max, len) {
      let res = []
      let i = 0
      do {
        let _r = parseInt(Math.random() * max) + 1
        if (res.indexOf(_r) == -1) {
          res[i] = _r
          i++
        }
      } while (i < len)

      res = res.sort(function(a, b) {
        return a - b
      })
      return res
    },
    getMedia() {
      let _this = this
      navigator.getUserMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia
      if (navigator.getUserMedia) {
        navigator.getUserMedia(
          {
            video: {
              optional: [
                {
                  sourceId: exArray[0], //0为前置摄像头，1为后置
                },
              ],
            },
            audio: false,
          },
          function(stream) {
            mediaStreamTrack = stream
            if (video.mozSrcObject !== undefined) {
              //Firefox中，video.mozSrcObject最初为null，而不是未定义的，我们可以靠这个来检测Firefox的支持
              video.mozSrcObject = stream
            } else {
              try {
                video.srcObject = stream
              } catch (error) {
                video.src = window.URL.createObjectURL(stream)
              }
            }

            canvas1.height = video.videoHeight > 0 ? video.videoHeight : 480
            canvas1.width = video.videoWidth > 0 ? video.videoWidth : 600
            video.style.display = 'block'
          },
          function(e) {
            _this.$message.warning('验证失败,请联系管理员')
          }
        ) //success是获取成功的回调函数
      } else {
        _this.$message.warning('请检查摄像头')
        return
      }
    },
    close_video() {
      // mediaStreamTrack.getTracks().forEach(function (track) {
      //         track.stop();
      //         video.src='';
      //         video.style.display='none'
      //     });
    },
    getPhoto() {
      context1.drawImage(video, 0, 0)
    },
    useTime() {
      //已用时间
      let _this = this,
        id = this.$route.params.id
      clearInterval(this.Storage.getStorage('timer'))
      if (this.exam.is_verify && this.exam.verify_nums > 0) {
        _this.getMedia()
      }

      function changeTime() {
        if (_this.useMinute != _this.exam.minutes) {
          if (_this.useSecond == 59) {
            _this.useMinute++
            _this.useSecond = 0
          } else {
            _this.useSecond++
          }
        } else {
          clearInterval(_this.timer)
          _this.timer = null
          _this.submit()
        }
        _this.obj.minute = _this.useMinute
        _this.obj.second = _this.useSecond

        _this.Storage.setStorage(id, _this.obj)
      }
      _this.localDate()
      _this.timer = setInterval(changeTime, 1000)
      _this.Storage.setStorage('timer', _this.timer)
    },
    localDate() {
      let _this = this,
        id = this.$route.params.id
      clearInterval(this.Storage.getStorage('endTimer')) //清除上一次的定时器
      this.$http
        .post(process.env.VUE_APP_API_URL + 'getTime', { id: id })
        .then(function(data) {
          let cha = data.data.time - parseInt(new Date().getTime() / 1000)
          let nowtime = parseInt(new Date().getTime() / 1000)
          let time_start =
            nowtime -
            new Date(data.data.res.created_at.replace(/-/g, '/')).getTime() /
              1000
          _this.obj.exam_time = Number(_this.exam.minutes) + 20
          _this.obj.start_time =
            new Date(data.data.res.created_at.replace(/-/g, '/')).getTime() /
            1000
          _this.Storage.setStorage(id, _this.obj)
          _this.s_to_hs(time_start)
          let falg = false
          _this.endTimer = setInterval(function() {
            if (_this.exam.minutes - _this.useMinute <= 0) {
              _this.disabled = true
            }
            if (_this.exam.minutes - _this.useMinute <= 10 && falg == false) {
              falg = true
              _this.$message({
                duration: 5000,
                message:
                  '本场考试还剩10分钟，请考生请考生抓紧时间答题或审核试卷，到时系统将自动收卷。',
                type: 'warning',
              })
            }
            // let time = data.data.endtime - nowtime - cha
            let time = _this.exam.minutes - _this.useMinute
            if (time > 0) {
              time--
            } else {
              clearInterval(_this.endTimer)
              _this.endTimer = null
              _this.submit()
            }
          }, 1000)
          _this.Storage.setStorage('endTimer', _this.endTimer)
        })
        .catch(function(error) {
          _this.$message.error({ message: '网络错误,请刷新界面重试' })
          return
        })
    },
    s_to_hs(s) {
      //计算分钟
      //算法：将秒数除以60，然后下舍入，既得到分钟数
      var h
      h = Math.floor(s / 60)
      //计算秒
      //算法：取得秒%60的余数，既得到秒数
      s = s % 60
      //将变量转换为字符串
      h += ''
      s += ''
      h = h.length == 1 ? h : h
      s = s.length == 1 ? s : s
      if (h == -1) {
        h = 0
      }
      if (s == -1) {
        s = 0
      }
      this.useMinute = h
      this.useSecond = s
    },
    fun(val, option) {
      let question = this.currentQues,
        exam = this.ques,
        type = question.type,
        i = 0

      if (type == 1 || type == 3) {
        //默认单选判断一经触发该方法状态即为选中
        question.check = true
        question.circleColor = 'primary'
      } else {
        if (question.is_select.length > 0) {
          question.check = true
          question.circleColor = 'primary' //通过判断value来判断是否选择了该题目
        } else {
          question.check = false
          question.circleColor = 'default'
        }
      }
      exam.forEach(item => {
        if (item.check) {
          i++
        }
      })
      this.progress = (i / exam.length) * 100
      let id = this.$route.params.id
      this.Storage.setStorage('ques' + id, this.ques)
      this.Storage.setStorage('progress' + id, this.progress)
      this.obj.ques = this.ques
      this.obj.progress = this.progress
      this.Storage.setStorage(id, this.obj.ques)
    },
    postImg() {
      let _this = this
      this.getPhoto()
      let imgData = document.getElementById('canvas1').toDataURL('image/png')
      let base64Data = imgData.replace(/^data:image\/\w+;base64,/, '')
      console.log(base64Data)
      let exampath = this.Storage.getStorage('exampath')
      let id = this.$route.params.id
      let from = {
        image: base64Data,
        time: exampath,
        id: id,
      }
      // document.getElementById("ba").src=imgData
      this.$http
        .post(process.env.VUE_APP_API_URL + 'match', from)
        .then(function(data) {
          if (data.data.code == 200) {
          } else {
            setTimeout(() => {
              _this.$message.error({ message: data.data.msg })
            }, 3000)
          }
        })
        .catch(function(error) {
          _this.$message.error({ message: '网络错误,请刷新界面重试' })
          return
        })
    },
    preQuestion() {
      //上一题
      this.i -= 1
      this.currentQues = this.ques[this.i]
    },
    nextQuestion() {
      //下一题
      this.i += 1
      this.currentQues = this.ques[this.i]

      if (this.exam.is_verify && this.exam.verify_nums > 0) {
        let id = this.$route.params.id
        let n = this.obj.is_img.indexOf(this.i)
        if (n > -1) {
          this.postImg()
          this.is_img = this.obj.is_img
          this.is_img.splice(n, 1)
          this.obj.is_img = this.is_img
          this.Storage.setStorage(id, this.obj)
        }
      }
    },
    toQuestion(i) {
      //跳转到某一题
      this.i = i
      this.activeNames = []
      this.currentQues = this.ques[this.i]
    },
    submit() {
      //提交试卷
      this.disabledBtn = true
      let questions = this.ques,
        submits = true, //记录是否答完所有题目
        _this = this
      questions.forEach(ques => {
        if (!ques.check) {
          submits = false
          return
        }
      })
      if (this.endTimer) {
        //如果时间没到
        if (!submits && this.timer) {
          this.$confirm(
            '您还有题目没有作答，是否依旧选择交卷？如继续答题，可点击答题卡查看未做题目。',
            {
              confirmButtonText: '交卷',
              cancelButtonText: '返回',
              closeOnClickModal: false,
            }
          )
            .then(() => {
              _this.loading = true
              _this.handlePaperData(_this.ques)
            })
            .catch(() => {
              _this.loading = false
              _this.disabledBtn = false
              _this.$message.warning('已取消，点击答题卡可查看未做题目！')
            })
        } else if (submits && this.timer) {
          // _this.handlePaperData(_this.ques);
          this.$confirm('您确定要交卷吗?提交后无法更改!', {
            confirmButtonText: '交卷',
            cancelButtonText: '取消',
            closeOnClickModal: false,
          })
            .then(() => {
              _this.loading = true
              _this.handlePaperData(_this.ques)
            })
            .catch(() => {
              _this.loading = false
              _this.disabledBtn = false
              _this.$message.warning('已取消，点击答题卡可查看未做题目！')
            })
        } else {
          //时间到了，直接交卷
          _this.loading = true
          this.$message.warning('考试时间到！')
          this.handlePaperData(this.ques)
        }
      }
    },
    handlePaper() {
      let data = this.Storage.getStorage(this.exam.pid)
      this.handlePaperData(data)
    },

    handlePaperData(data) {
      this.close_video()
      let option = [],
        ques
      ques = JSON.parse(JSON.stringify(data))
      ques.forEach(item => {
        option.push({
          id: item.id,
          type: item.type,
          options: item.is_select,
        })

        item.options = JSON.stringify(item.options)
      })
      let exam = JSON.parse(JSON.stringify(this.exam))
      exam.usedTime = this.useMinute * 60 + this.useSecond
      exam.question = JSON.stringify(option)
      let _this = this,
        id = this.$route.params.id
      this.$http
        .post(process.env.VUE_APP_API_URL + 'paper', exam)
        .then(function(data) {
          _this.disabledBtn = false
          _this.loading = false
          if (data.data.code == 200) {
            clearInterval(_this.timer)
            clearInterval(_this.endTimer)
            _this.timer = null
            _this.endTimer = null
            _this.Storage.delStorage(id)
            _this.Storage.delStorage('timer')
            _this.Storage.delStorage('endTimer')
            if (data.data.type == 2) {
              //如果是考试卷
              _this
                .$confirm('考试结束，成绩请咨询主考学校！', {
                  confirmButtonText: '确定',
                  closeOnClickModal: false,
                  showClose: false,
                  showCancelButton: false,
                })
                .then(() => {
                  let id = _this.$route.params.id
                  if (_this.exam.skip_url) {
                    //考试结束跳转
                    _this.$router.push({ name: 'entrance', params: { id: id } })
                    window.open(_this.exam.skip_url)
                  } else {
                    _this.$router.push({ name: 'entrance', params: { id: id } })
                  }
                })
            } else {
              //如果是测试卷显示考试结果
              _this.result = data.data.data
              _this.showResult = true //显示结果页
            }
          } else {
            _this.$message.error(data.data.msg)
            _this.$router.push({ name: 'entrance' })
          }
        })
        .catch(function(error) {
          _this.disabledBtn = false

          _this.$message.error({ message: '网络错误,请刷新界面重试' })
          return
        })
    },

    checkPaper() {
      this.showResult = false
      this.is_new = 0
      this.init()
    },
    resetPaper() {
      let _this = this
      // if (_this.exam.type == 1) {
      //   //测验卷
      //   if (event >= 80 || _this.result.score >= 80) {
      //     // _this.$message.error({ message: '你的考试成绩已合格，无需重做！' })
      //     _this.$message.error({ message: '你已获得优良成绩，无需重做！' })
      //     return false
      //   }
      // }
      let id = _this.exam.id
      if (_this.exam.type == 5) {
        id = _this.exam.pid
      }
      _this.is_new = 1
      _this.showResult = false
      _this.$http
        .post(process.env.VUE_APP_API_URL + 'delRes', { id: id })
        .then(function(data) {
          _this.Storage.delStorage(id)
          _this.Storage.delStorage('ques' + id)
          _this.Storage.delStorage('exam' + id)
          _this.$router.push({ name: 'entrance', params: { id: id } })
          _this.init()
        })
        .catch(function(error) {
          _this.$message.error({ message: '网络错误,请刷新界面重试' })
          return
        })
    },
    toRefresh() {
      window.location.href('')
    },
    showAnswer(que) {
      // this.$message.error('error')
      this.currentQues.showParsing = que.parsing != '' ? true : false
      let options = que.options //拿到每道题的可选项
      let arr = []

      options.forEach(option => {
        //标记所有题目的正确选项
        option.greenBg = false
        option.redBg = false
        if (option.is_right) {
          option.bgColor = true
          option.greenBg = true
          arr.push(option.id)
        }
      })

      let select = false
      if (que.type == 2 && que.is_select.length != 0) {
        select = true
        let len = que.is_select.length
        if (len == arr.length) {
          arr.forEach(i => {
            if (que.is_select.indexof(i) != -1) {
              que.is_right = true
            } else {
              que.is_right = false
              return
            }
          })
        } else {
          que.is_right = false
        }
      } else if (que.type != 2 && que.is_select != '') {
        select = true
        if (arr[0] == que.is_select) {
          que.is_right = true
        } else {
          que.is_right = false
        }
      }

      if (!que.is_right && select) {
        //如果做错了题
        que.circleColor = 'danger' //根据得分情况以及选择与否改变答题卡的颜色

        options.forEach(option => {
          //如果做错了题，将错题标记
          if (que.type == 1 || que.type == 3) {
            if (option.id == que.is_select) {
              option.bgColor = true
              option.redBg = true
            }
          } else if (que.type == 2) {
            que.is_select.forEach(i => {
              if (!option.is_right && option.id == i) {
                //如果选项是错的，但是选择的选择与该选项的id一样，那么标红
                option.bgColor = true
                option.redBg = true
              }
            })
          }
        })
      } else if (que.is_right) {
        que.circleColor = 'success'
      }
      this.Storage.setStorage(this.exam.id, this.obj)
      this.$forceUpdate()
    },
    IsPC() {
      var userAgentInfo = navigator.userAgent
      var Agents = [
        'Android',
        'iPhone',
        'SymbianOS',
        'Windows Phone',
        'iPad',
        'iPod',
      ]
      var flag = true
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false
          break
        }
      }
      return flag
    },
    toClearRecord(paper_id) {
      let _this = this
      this.$confirm('此操作将清除所有答题记录', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
      })
        .then(() => {
          _this.progress = 0
          _this.i = 0
          _this.Storage.delStorage(this.exam.id)
          _this.init()
        })
        .catch(() => {
          _this.$message.warning('已取消，可继续答题！')
        })
    },
  },
}
</script>
<style lang="less" scope>
.el-collapse-item__header {
  line-height: 40px !important;
  height: 40px !important;
  display: block !important;
  text-align: center;
  color: #1890ff !important;
}
.el-message-box {
  width: 80% !important;
}
.exam {
  max-width: 1000px !important;
  margin: 0 auto;
  // background-image:url('../assets/bg.png');
  background-image: linear-gradient(#096dd9, #83bdf9);
  padding-bottom: 20px;
  background-size: 100% 100%;
  font-size: 14px;
  position: relative;
  overflow-y: atuo;
  .el-header {
    padding: 10px;
    .el-row {
      text-align: left;
      padding: 5px;
      color: #fff;
      font-size: 13px;
    }
  }
  .el-main {
    border-radius: 8px;
    background: #fff;
    margin: 0 10px;
    .publicDesc {
      display: flex;
      justify-content: space-between;
      height: 30px;
      line-height: 30px;
      .examGrade > strong {
        font-size: 16px;
      }
    }
    .content {
      width: 100%;
      box-sizing: border-box;
      .queTitle {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        font-size: 18px;
      }
    }
    .el-collapse {
      border: none !important;
      .el-col {
        padding: 3px;
        .el-button {
          width: 40px;
          height: 40px;
          text-align: center;
          padding: 5px;
        }
      }
    }
    .radioAnswer {
      padding: 5px;
    }
    .answers {
      min-height: 280px;
      .option {
        margin: 0;
        padding: 8px 0;
        display: flex;
        height: auto;
        overflow: hidden;
        word-break: break-all;
        overflow-wrap: break-word;
        font-size: 17px;
        line-height: 17px;
      }
    }
    .footer {
      text-align: right;
      .el-button + .el-button {
        margin-left: 50px;
      }
    }
    .submit {
      padding-top: 40px;
      text-align: center;
    }
    .examMsg {
      color: #928b8b;
    }
  }
}
// 未选中样式

.bgRed {
  background-color: #fff1f2;
  color: #f93a4e;
}
.bgGreen {
  background-color: #edfffd;
  color: #1ca194 !important;
}
.el-radio__input.is-disabled + span.el-radio__label,
.el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #666 !important;
}
.bgGreen .el-radio__input.is-disabled + span.el-radio__label,
.bgGreen .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #1ca194 !important;
}
.bgRed .el-radio__input.is-disabled + span.el-radio__label,
.bgRed .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #f93a4e !important;
}
.bgGreen .el-radio__input.is-disabled.is-checked .el-radio__inner::after,
.bgRed .el-radio__input.is-disabled.is-checked .el-radio__inner::after,
.bgRed .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after,
.bgGreen .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  background-color: #000;
}
.el-radio {
  margin-right: 0 !important;
  .el-radio__inner {
    border-color: #999;
  }
}
.el-checkbox {
  .el-checkbox__inner {
    border-color: #999;
  }
}
.el-radio__input.is-disabled .el-radio__inner,
.el-radio__input.is-disabled.is-checked .el-radio__inner,
.el-checkbox__input.is-disabled .el-checkbox__inner {
  border-color: #999 !important;
}
.el-button--danger {
  background-color: #f93a4e !important;
}
.el-button--success {
  background-color: #1ca194 !important;
}
.el-radio__label,
.el-checkbox__label {
  font-size: 16px !important;
  white-space: normal;
  margin-right: 10px;
}
.el-collapse-item__header {
  font-size: 16px !important;
}
.queName {
  line-height: 20px;
  font-size: 18px;
}
.queName p {
  margin: 0;
}
.video {
  position: fixed;
  z-index: 999;
  width: 230px;
  height: 150px;
  overflow: hidden;
  top: 10px;
  right: 10px;
  video,
  canvas {
    width: 100%;
    height: 100%;
  }
}
.quetype {
  color: red;
  font-size: 16px;
  white-space: nowrap;
}
.dot {
  font-family: simsun;
}
:root .dot {
  display: inline-block;
  width: 1.5em;
  vertical-align: bottom;
  overflow: hidden;
}
@-webkit-keyframes dot {
  0% {
    width: 0;
    margin-right: 1.5em;
  }
  33% {
    width: 0.5em;
    margin-right: 1em;
  }
  66% {
    width: 1em;
    margin-right: 0.5em;
  }
  100% {
    width: 1.5em;
    margin-right: 0;
  }
}
.dot {
  -webkit-animation: dot 3s infinite step-start;
}

@keyframes dot {
  0% {
    width: 0;
    margin-right: 1.5em;
  }
  33% {
    width: 0.5em;
    margin-right: 1em;
  }
  66% {
    width: 1em;
    margin-right: 0.5em;
  }
  100% {
    width: 1.5em;
    margin-right: 0;
  }
}
.dot {
  animation: dot 3s infinite step-start;
}

#overlay,
.overlay {
  position: absolute;
  top: 0;
  left: 0;
}

@media screen and (min-device-width: 600px) {
  .el-message-box {
    width: 400px !important;
  }
}
</style>
